import React, {Component} from "react";
import Logo from "../../../images/logo.png";

class TokenAd extends Component{

    constructor(props){
        super(props);
        this.state = {
            
        }
    }

    render(){
        return(
            <div className="breadcrumb-area">
                <div className="br-10 sec-bg tokenad-widget">
                    <h3>WLOCTT TOKEN (LOTT)</h3>
                    <p className="under-text"></p>
                    <div className="rounds-flex">
                        <div className="token-ads-content">
                            <h4 className="sec-txt">LOTT are used for: </h4>
                            <div className="token-ads-child">
                                <div className="token-ads-info-inline">
                                    <div className="token-ads-info">
                                        <i className="fi fi-rr-check prim-txt"></i>
                                        <div className="small-txt sec-txt">
                                            HIncubated pools are the most exclusive pools on our platform. They give you early access to projects as an investor at public IDO stage and are usually exclusive to LIGHT holders only.
                                        </div>
                                    </div>
                                </div>
                                <div className="token-ads-info-inline">
                                    <div className="token-ads-info">
                                        <i className="fi fi-rr-check prim-txt"></i>
                                        <div className="small-txt sec-txt">
                                            HIncubated pools are the most exclusive pools on our platform. They give you early access to projects as an investor at public IDO stage and are usually exclusive to LIGHT holders only.
                                        </div>
                                    </div>
                                </div>
                                <div className="token-ads-info-inline">
                                    <div className="token-ads-info">
                                        <i className="fi fi-rr-check prim-txt"></i>
                                        <div className="small-txt sec-txt">
                                            HIncubated pools are the most exclusive pools on our platform. They give you early access to projects as an investor at public IDO stage and are usually exclusive to LIGHT holders only.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="token-ads-img-widget">
                            <img src={Logo} />
                            <button>Buy Now </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TokenAd;

